import axios, { AxiosPromise } from 'axios'
import { SnowflakeResult } from '@/interfaces/snowflake'
import { Widget } from '@/interfaces/custom-dashboard'

const NON_FILTER_WIDGET_TYPES = ['table', 'table-by-value', 'text', 'blank', 'report', 'form-dynamic-text']

export function getData (query: string, queryLimit: number): AxiosPromise<SnowflakeResult> {
  return axios({
    method: 'post',
    url: process.env.VUE_APP_API_URI + '/snowflake/queries',
    timeout: 1000 * 60 * 5, // wait for 5 minutes
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      query: query,
      limit: queryLimit,
      offset: 0,
      batchSize: queryLimit
    }
  })
}

export function isWidgetFilter (widget: Widget): boolean {
  return Boolean(widget.metadata && widget.metadata.type && !NON_FILTER_WIDGET_TYPES.includes(widget.metadata.type))
}

// Takes in an array of string and transforms into a list string that is to be passed onto
// the IN function of Snowflake. Adds a backslash when necessary to escape single quotes to prevent
// breaking queries on Snowflake.
// Example: ["dog", "can't", "apple"] => "'dog', 'can\'t', 'apple'"
export function createInListString (values: string[]): string {
  return values.filter(value => value).map(value => `'${value.replace(/'/g, "\\'")}'`).join(', ') || "''"
}

export function createHolidayQuery (startDate: string, endDate: string, regionIds: number[], dateAgg: string) {
  return `
    SELECT * FROM production_data.public.region_holidays_view
    WHERE calendar_date between date('${startDate}') and date('${endDate}')
    AND (${regionIds.map(regionId => `region_id = ${regionId}`).join(' OR ') || 'false'})
    AND date_agg = '${dateAgg}' AND holiday is not null;
  `
}

export function createWeatherQuery (startDate: string, endDate: string, regionIds: number[], dateAgg: string) {
  return `
    SELECT * FROM production_data.public.region_weather_view
    WHERE calendar_date between date('${startDate}') and date('${endDate}')
    AND (${regionIds.map(regionId => `region_id = ${regionId}`).join(' OR ') || 'false'})
    AND date_agg = '${dateAgg}';
  `
}
